
define('text!templates/modules/setting/business/payment/payment-safety-notice.html',[],function () { return '<img class="img-responsive" src="assets/images/shield_lock.png" alt="">\n<span>{{#t}}payment:safety_notice{{/t}}</span>\n';});

